import { Outlet, redirect } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { queueQueryOptions } from "@/server/queues";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";
import _ from "lodash";

export const Route = createFileRoute("/_dashboard/queues/$queueId")({
  component: RouteComponent,
  beforeLoad: ({ location, params }) => {
    const routeParts = _.compact(location.pathname.split("/"));
    const isExactQueueRoute =
      routeParts[routeParts.length - 2] === "queues" &&
      (routeParts[routeParts.length - 1] === params.queueId ||
        routeParts[routeParts.length - 1] === `${params.queueId}/`);
    if (isExactQueueRoute) {
      throw redirect({
        to: "/queues/$queueId/edit",
        params: { queueId: params.queueId },
      });
    }
  },
  loader: async ({ params, context }) => {
    const queryOptions = queueQueryOptions(Number(params.queueId));
    //We need to prefetch the query in order to get the name for the breadcrumb
    await context.queryClient.prefetchQuery(queryOptions);
    const queue = context.queryClient.getQueryData(queryOptions.queryKey) as { name?: string } | undefined;

    return {
      queueId: params.queueId,
      crumb: queue?.name,
      dehydratedState: dehydrate(context.queryClient) as any,
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData();
  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
